import { createDCHook } from '../../client';
import { getV1SmartthermostatGeneratedswagger } from '../../services/smartthermostat/OpenApiSpecificationsService';

export const useOpenApiSpecificationsGetV1SmartthermostatGeneratedswagger = createDCHook(
  'getV1SmartthermostatGeneratedswagger',
  getV1SmartthermostatGeneratedswagger,
  { injectables: [], flattenData: false },
);
